import { css, keyframes, styled } from '@mui/material'

const shakeHorizontal = keyframes`
  0% { transform: translateX(0); }
  10% { transform: translateX(-10px); }
  20% { transform: translateX(10px); }
  30% { transform: translateX(-10px); }
  40% { transform: translateX(10px); }
  50% { transform: translateX(-6px); }
  60% { transform: translateX(6px); }
  70% { transform: translateX(-3px); }
  80% { transform: translateX(3px); }
  90% { transform: translateX(-1px); }
  100% { transform: translateX(0); }
`

export const Wrapper = styled('div')<{ error?: boolean }>`
  ${({ error }) =>
    error &&
    css`
      animation: ${shakeHorizontal} 0.6s ease-in-out;
    `}
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding-top: ${({ theme }) => theme.spacing(5)};
`

export const PinListWrapper = styled('div')`
  display: flex;
  justify-content: center;
  height: ${({ theme }) => theme.spacing(5.25)};
  gap: ${({ theme }) => theme.spacing(1)};
`
